import { Link, useNavigate } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Api, SecondaryApi } from "../api/baseApi";
import { useTranslation } from "react-i18next";
import { useEffect, useRef, useState } from "react";

const CartPayment = () => {
  const { t } = useTranslation();
  const [message, setMessage] = useState(null);
  const [communities, setCommunities] = useState([]);
  const [step, setStep] = useState(1);
  const [services, setServices] = useState([]);
  const [errorMessages, setErrorMessages] = useState([]);
  const [initialValues, setInitialValues] = useState({
    community_id: "",
    service_id: "",
    identification_data: "",
    identification_data: "code",
  });
  const navigatedToPayRef = useRef(false);
  let identificationTypes = [
    {
      key: "phone",
      value: "Հեռախոսահամար",
    },
    {
      key: "psn",
      value: "ՀԾՀ կամ ՀՎՀՀ",
    },
    {
      key: "code",
      value: "Բաժանորդային կոդ",
    },
  ];

  const navigate = useNavigate();

  useEffect(() => {
    async function getCommunities() {
      try {
        const response = await SecondaryApi.get(`/api/get-communities`);
        setCommunities(response.data);
        let storageData = JSON.parse(sessionStorage.getItem("cartData"));
        if (storageData) {
          const resp = await fecthServices(storageData.community_id);
          setInitialValues(storageData);
          setStep(2);
        } else {
          setInitialValues({
            community_id: response.data.length ? response.data[0].id : "",
            service_id: "",
            identification_data: "",
            identification_type: "code",
          });
          setStep(1);
        }
      } catch (error) {
        console.error(error);
      }
    }
    getCommunities();
  }, []);

  useEffect(() => {
    return () => {
      if (!navigatedToPayRef.current) {
        sessionStorage.removeItem("paymentData");
        sessionStorage.removeItem("cartData");
      }
    };
  }, []);

  const validationSchema = Yup.object({
    community_id: Yup.string().required("Դաշտը պարտադիր է"),
    service_id:
      step === 2 ? Yup.string().required("Դաշտը պարտադիր է") : Yup.string(),
    identification_data:
      step === 2
        ? Yup.string()
            .required("Դաշտը պարտադիր է")
            .matches(/^\S.*\S$|^\S$/, "Դաշտը չպետք է պարունակի բացատներ")
        : Yup.string(),
  });

  async function fecthServices(community_id) {
    try {
      const response = await SecondaryApi.get(
        `/api/communities/${community_id}/services`,
      );

      const fetchedServices = response.data;

      setServices(fetchedServices);
      return response.data;
    } catch (error) {}
  }

  async function handleFormSubmit(values, { setFieldValue, resetForm }) {
    if (step === 1) {
      try {
        const fetchedServices = await fecthServices(values.community_id);

        setStep(2);

        if (fetchedServices.length > 0) {
          setFieldValue("service_id", String(fetchedServices[0].id));
        }
      } catch (error) {
        console.error(error);
      }
    } else {
      try {
        let payload = {
          community_id: values.community_id,
          service_id: values.service_id,
          identification_data: values.identification_data,
        };
        const response = await SecondaryApi.post(
          `/api/apartment-identification`,
          payload,
        );
        if (response?.data?.data) {
          let data = response.data.data;
          setErrorMessages("");
          sessionStorage.setItem("paymentData", JSON.stringify(data));
          sessionStorage.setItem("cartData", JSON.stringify(payload));

          navigatedToPayRef.current = true;
          navigate("pay");
        }
      } catch (error) {
        if (error.response) {
          let errResponse = error.response.data;
          if (errResponse && errResponse.ResponseMessage) {
            setErrorMessages(errResponse.ResponseMessage);
          }
        } else if (error.request) {
          console.log("No response received:", error.request);
        } else {
          console.log("Error:", error.message);
        }
      }
    }
  }

  return (
    <section className="contact padding-t-60 padding-b-60 section-bg position-relative z-index-1 overflow-hidden">
      <div className="container container-two">
        <div className="row">
          <div className="payment-container">
            <div className="card common-card p-sm-4">
              <div className="card-body payment-cart">
                <Formik
                  initialValues={initialValues}
                  validationSchema={validationSchema}
                  onSubmit={handleFormSubmit}
                  enableReinitialize
                  validateOnBlur={true}
                  validateOnChange={false}
                >
                  {({
                    isSubmitting,
                    isValid,
                    values,
                    setFieldValue,
                    resetForm,
                    errors,
                    touched,
                    submitCount,
                    setTouched,
                  }) => {
                    return (
                      <Form autoComplete="off">
                        <div className="row gy-4 ">
                          <h5 className="payment-heading__title">
                            {" "}
                            {t("paymentContent.form_title")}
                          </h5>

                          {/* message */}
                          <p
                            className={`${message?.status ? "text-success" : "text-danger"}`}
                          >
                            {message?.message}
                          </p>

                          <div>
                            <label
                              htmlFor="community_id"
                              className="form-label mb-2 font-18 font-heading fw-600"
                            >
                              Ընտրեք ձեր Համայնքը
                            </label>

                            <Field
                              as="select"
                              name="community_id"
                              className="common-input border"
                              onChange={(e) => {
                                const value = e.target.value;
                                setFieldValue("community_id", value);
                                setStep(1);
                                setServices([]);
                                setFieldValue("service_id", "");
                                setFieldValue("identification_data", "");
                              }}
                            >
                              {communities.map((community) => (
                                <option key={community.id} value={community.id}>
                                  {community.name}
                                </option>
                              ))}
                            </Field>

                            <ErrorMessage
                              name="community_id"
                              component="div"
                              className="text-danger small mt-1"
                            />
                          </div>

                          {step === 2 && (
                            <>
                              <div className="filter-sidebar__content">
                                <label className="form-label">
                                  Ընտրել ծառայություն
                                </label>

                                {services.map((service) => (
                                  <div
                                    className="common-check common-radio"
                                    key={service.id}
                                  >
                                    <Field
                                      className="form-check-input"
                                      type="radio"
                                      name="service_id"
                                      value={String(service.id)}
                                      id={`service_id_${service.id}`}
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor={`service_id_${service.id}`}
                                    >
                                      {service.name}
                                    </label>
                                  </div>
                                ))}

                                <ErrorMessage
                                  name="service_id"
                                  component="div"
                                  className="text-danger"
                                />
                              </div>

                              <div className="">
                                <label
                                  htmlFor="name"
                                  className="form-label mb-2 font-18 font-heading fw-600"
                                >
                                  Նույնականացման տվյալներ
                                </label>

                                <div
                                  className="d-flex align-items-center w-100 rounded"
                                  style={{
                                    minHeight: "35px",
                                    padding: "0 6px",
                                    gap: "10px",
                                    background: "#E8ECFD",
                                    marginBottom: "12px",
                                  }}
                                >
                                  <img
                                    src="/assets/images/icons/info-circle.svg"
                                    alt=""
                                    width={20}
                                    height={20}
                                  />
                                  <p
                                    className="fw-medium"
                                    style={{
                                      color: "#002BBA",
                                      fontSize: "14px",
                                      lineHeight: "27px",
                                    }}
                                  >
                                    Մուտքագրեք Բաժանորդային կոդը, ՀԾՀ/ՀՎՀՀ-ն կամ
                                    հեռախոսահամարը:
                                  </p>
                                </div>

                                <div className="filter-sidebar__content">
                                  <label className="form-label">
                                    Ընտրել նույնականացման տեսակը
                                  </label>

                                  {identificationTypes.map((item) => (
                                    <div
                                      className="common-check common-radio"
                                      key={item.key}
                                    >
                                      <Field
                                        className="form-check-input"
                                        type="radio"
                                        name="identification_type"
                                        value={item.key}
                                        id={`identification_type_${item.key}`}
                                        onChange={(e) => {
                                          const type = e.target.value;

                                          setFieldValue(
                                            "identification_type",
                                            type,
                                          );

                                          if (type === "phone") {
                                            setFieldValue(
                                              "identification_data",
                                              "+374",
                                            );
                                          } else {
                                            setFieldValue(
                                              "identification_data",
                                              "",
                                            );
                                          }
                                        }}
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor={`identification_type_${item.key}`}
                                      >
                                        {item.value}
                                      </label>
                                    </div>
                                  ))}

                                  <ErrorMessage
                                    name="identification_type"
                                    component="div"
                                    className="text-danger"
                                  />
                                </div>

                                <Field
                                  type="text"
                                  name="identification_data"
                                  id="identification_data"
                                  className="common-input common-input--grayBg border"
                                  onChange={(e) => {
                                    let value = e.target.value;

                                    if (
                                      values.identification_type === "phone"
                                    ) {
                                      if (!value.startsWith("+374")) {
                                        value = "+374";
                                      }
                                    }

                                    setFieldValue("identification_data", value);
                                    setErrorMessages("");
                                    setTouched({
                                      ...touched,
                                      identification_data: true,
                                    });
                                  }}
                                  onKeyDown={(e) => {
                                    if (
                                      values.identification_type === "phone" &&
                                      e.target.selectionStart <= 4 &&
                                      (e.key === "Backspace" ||
                                        e.key === "Delete")
                                    ) {
                                      e.preventDefault();
                                    }
                                  }}
                                />
                                {(touched.identification_data ||
                                  submitCount > 0) &&
                                  errors.identification_data && (
                                    <div className="text-danger small mt-1">
                                      {errors.identification_data}
                                    </div>
                                  )}

                                {errorMessages && (
                                  <div className="text-danger small mt-1">
                                    {errorMessages}
                                  </div>
                                )}
                              </div>
                            </>
                          )}

                          {/* <div className="filter-sidebar__content">
                          <label
                            htmlFor="Countryyy"
                            className="form-label mb-2 font-18 font-heading fw-600"
                          >
                            Ընտրել ծառայություն
                          </label>
                          <ul className="filter-sidebar-list">
                            <li className="filter-sidebar-list__item">
                              <div className="filter-sidebar-list__text">
                                <div className="common-check common-radio">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name="radio"
                                    id="oneStar"
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="oneStar"
                                  >
                                    Աղբահանություն
                                  </label>
                                </div>
                              </div>
                            </li>
                            <li className="filter-sidebar-list__item">
                              <div className="filter-sidebar-list__text">
                                <div className="common-check common-radio">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name="radio"
                                    id="twoStar"
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="twoStar"
                                  >
                                    2 Star and above
                                  </label>
                                </div>
                              </div>
                            </li>
                          </ul>
                        </div>

                        <div className="col-sm-6 col-xs-6">
                          <label
                            htmlFor="name"
                            className="form-label mb-2 font-18 font-heading fw-600"
                          >
                            {t("contactUs.contactForm.fullName")}
                          </label>
                          <Field
                            type="text"
                            name="name"
                            id="name"
                            className="common-input common-input--grayBg border"
                            placeholder={t("contactUs.placeholders.fullName")}
                          />
                          <ErrorMessage
                            name="name"
                            component="div"
                            className="text-danger small mt-1"
                          />
                        </div> */}

                          {/* Submit */}
                          <div className="col-sm-12">
                            <button
                              id="contact-us-form-button"
                              className="btn btn-main btn-lg pill w-100"
                              type="submit"
                              disabled={
                                isSubmitting ||
                                (step === 2 &&
                                  (!values.service_id ||
                                    !values.identification_data))
                              }
                            >
                              <img
                                src="/assets/images/icons/search-refraction.svg"
                                alt="search"
                              />
                              {t("paymentContent.search")}
                            </button>
                          </div>
                        </div>
                      </Form>
                    );
                  }}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CartPayment;
